<template>
<div id="checkApple" class="content" ref="checkApple" v-show="isShow">
    <div class="title">
        <span>{{$t('language.popup.checkApplePopup.title')}}</span>
        <div class="icon white-close dialog-close" @click="close()"></div>
    </div>
    <div class="content-body">
        <div class="popup-title-tips">
            {{$t('language.popup.checkApplePopup.tip1')}}
        </div>
        <div class="">
            <codeInput ref="codeInput" :len=6 :singleRule="'num'"></codeInput>
        </div>
        <div class="resend-tips">
            <div class="resend-tip" v-if="!isReShow"><span @click="isReShow=true">{{$t('language.popup.checkApplePopup.tip2')}}</span></div>
            <div class="resend-tip" v-else>
                <div v-if="loadingRe">
                    <span style="user-select: none;color: #7AA7FF;">
                        <img src="../../../assets/images/workspace/loading_16.gif" align="center">
                        {{$t('language.popup.checkApplePopup.btn1')}}
                    </span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
                </div>
                <div v-else>
                    <span @click="resend()">{{$t('language.popup.checkApplePopup.btn2')}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span @click="reSMS()">{{$t('language.popup.checkApplePopup.btn3')}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                </div>
                <span @click="getSupport()">{{$t('language.popup.checkApplePopup.btn4')}}</span>
            </div>
        </div>
        <button @click="submitOk()" >
            <span class="button-tip" v-show="!$parent.connect">{{$t('language.common.ok')}}</span>
            <span class="button-tip" v-show="$parent.connect">
                {{$t('language.common.connecting')}}
                <span class="cloudDotting"></span>
            </span>
        </button>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";

import codeInput from '@/components/common/input/code_input';
export default {
    data: function () {
        return {
            isShow: false,
            code: "",
            isReShow: false,//是否展示重发
            loadingBtn: false,//ok按钮
            loadingRe: false,//重发
            authUrl: "",//授权地址
            cs: "security",//验证码类型
            driverType: "",
            parentPopopName: "",//父弹窗
        }
    },
    components: {
        codeInput,
    },
    methods: {
        close(){
            this.isShow=false;
            this.authUrl = "";
            this.driverType = "";
            this.$parent.isTempClose = false;//重新显示父级弹窗
        },
        initShow(authUrl,driverType,parentPopopName) {
            this.code = "";
            this.isReShow = false;
            this.loadingBtn = false;
            this.loadingRe = false;
            this.cs = "security";
            this.$refs.codeInput.init();
            this.authUrl = authUrl;
            this.isShow = true;
            this.driverType = driverType;
            this.parentPopopName = parentPopopName;
            this.$parent.isTempClose = true;//暂时关闭父级弹窗
        },
        resend() {
            this.cs = "security";
            this.sendCode();
        },
        reSMS() {
            this.cs = "sms";
            this.sendCode();
        },
        sendCode(){
            var user = commonUtils.getUser();
            var data = {
                ud: user.id,
                authUrl: this.authUrl,
                cs: this.cs,
                dt: this.driverType,
            }
            //重发验证码自动清空
            this.$refs.codeInput.init();
            this.loadingRe = true;
            this.Utils.doDrivesRequest("send_code", data).then(res => {
                this.loadingRe = false;
                if(res.status == 200){
                    if(this.cs == "sms" && res.phoneNumber){
                        this.$toast({
                            text: this.$t('language.popup.checkApplePopup.suc1',{num:res.phoneNumber}),
                            type: 'success',
                            idValue: this.parentPopopName+'Cloud',
                        });
                    }else{
                        //默认security
                        this.$toast({
                            text: this.$t('language.popup.checkApplePopup.suc2'),
                            type: 'success',
                            idValue: this.parentPopopName+'Cloud',
                        });
                    }
                }else{
                    if(this.$t('language.exception.' + res.reason)){
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: this.parentPopopName+'Cloud',
                        });
                    }else{
                        this.$toast({
                            text: this.$t('language.popup.checkApplePopup.fail1'),
                            type: 'fail',
                            idValue: this.parentPopopName+'Cloud',
                        });
                    }
                }
            })
        },
        submitOk() {
            this.code = this.$refs.codeInput.getCode();
            if(this.code.length<1){
                this.$toast({
                    text: this.$t('language.popup.checkApplePopup.fail2'),
                    type: 'fail',
                    idValue: this.parentPopopName+'CloudPopup',
                });
            }
            if(this.parentPopopName == 'add'){
                this.$parent.addDrive();
            }else if(this.parentPopopName == 'edit'){
                this.$parent.rewriteDrive();
            }
        },
        getSupport(){
            window.open('https://www.multcloud.com/support','_blank');
        }
    }
}
</script>
<style scoped>
#checkApple {
    width: 680Px;
    height: 315Px;
    font-family: Arial;
}

#checkApple .content-body {
    display: flex;
    flex-direction: column;
}

.popup-title-tips {
    height: 40Px;
    font-size: 14Px;
    font-weight: 400;
    line-height: 21Px;
    color: #000000;
    margin: 20Px;
}

.resend-tips {
    font-size: 14Px;
    font-family: Arial;
    font-weight: 400;
    line-height: 14Px;
    color: #4281FF;
    user-select: none;
    margin: 30px 20Px;
}

.resend-tip {
    display: flex;
}

.resend-tip span{
    cursor: pointer;
}

.resend-tip span:hover{
    cursor: pointer;
    text-decoration:underline;
}

#checkApple button {
    min-width: 110Px;
    float: right;
    position: absolute;
    bottom: 20Px;
    right: 20Px;
}

#checkApple button .button-tip {
    margin: 0 10Px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/check_apple_popup.vue